import { Icon } from "@equidefi/ui/icon";
import React from "react";

export type TEntityType = "INDIVIDUAL" | "ENTITY" | "JOINT" | "TRUST";

type TEntityTypeIconProps = {
  type?: TEntityType | null;
  size?: string;
  fallback?: React.ReactNode;
};

const ENTITY_TYPE_ICON_MAP = {
  INDIVIDUAL: Icon.User,
  JOINT: Icon.Users,
  TRUST: Icon.FileText,
  ENTITY: Icon.Briefcase,
} as const;

export const EntityTypeIcon: React.FC<TEntityTypeIconProps> = ({ type, size = "1em", fallback }) => {
  const IconComponent = type ? ENTITY_TYPE_ICON_MAP[type] : null;

  if (!IconComponent) {
    return fallback ?? <Icon.HelpCircle size={size} />;
  }

  return <IconComponent size={size} />;
};
